export default __webpack_public_path__ + "static/TrendTechnologiesIndia-6f3820871b1f9663ccca36794cb45b4c.jpg";